// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SidebarMenu_sidebar__XnCy8","arrows":"SidebarMenu_arrows__1WBLC","toggler":"SidebarMenu_toggler__g30uV"};